import React, {useState, useEffect, useRef} from 'react';
import { withRouter } from 'react-router-dom';
import './campaignSale.css';
import '@fontsource/open-sauce-one';
import ProgressMeter from './components/progressMeter/progressMeter';
import baseURLGlobal from '../../utils/util';
import SleekCarousel from './components/sleekCarousel';
import Lottie from "react-lottie";
import iconAnimation from '../../assets/json/web-top-icon.json';
import holititle from '../../assets/images/happy-holi-web-logo.png';
import arrowright from '../../assets/images/arrow-right-web-icon-2026.png';
import {config}  from '../../appConfig';
import pts from '../../assets/images/pts.png'
const Campaign = (props) => {
	const [data, setData] = useState(null);
	const [showTutorFrame, setShowTutorFrame] = useState(false);
	const [frameUrl, setFrameUrl] = useState("");
	const iframeRef = useRef(null);
	const [isOpen, setIsOpen] = useState(true);

	const baseUrl = baseURLGlobal;
	const urlParams = new URL(window.location.href);
	const token = urlParams.searchParams.get("token");

	const coinTasksData = data?.statCardWeb?.filter((item) => !item?.isComplete);
	const bottomCardWebData = data?.bottomCardWeb;
	const campaignOrg = data?.campaignOrg;
	const tutorData = data?.tutorOfTheDayCard;

	const campUrl = config?.BANNER_URL;

	const iconAnimationFile = {
		loop: true,
		autoplay: true,
		animationData: iconAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};


	const openFrameFun = (type) => {
		// const urlBase = "https://campaigns.classplus.co/tutor/details/";
		const urlBase = `${campUrl}/tutor/details/`;
		let url;
		switch (type) {
			case "overview":
				url = `${urlBase}overview?token=${token}`;
				break;
			case "leaderboard":
				url = `${urlBase}leaderboard?token=${token}`;
				break;
			default:
				url = `${urlBase}tasks?token=${token}`;
		}
		setFrameUrl(url);
		setShowTutorFrame(true);
	};

	useEffect(() => {
		var myHeaders = new Headers();
		myHeaders.append('x-access-token', token);
		var requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow',
		};
		fetch(`${baseUrl}/v1/campaign/homeCard`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				setData(result.data);
			});
	},[]);

	const closedTutorFrameFun = () => {
		setShowTutorFrame(false);
		setFrameUrl("");
	};

	useEffect(() => {
		const handleMessage = (event) => {
			const trustedOrigin = "https://campaigns.classplus.co";
			if (event.origin === trustedOrigin) {
				if (event.data?.type === "superSetOpened") {
					setIsOpen(false);
				} else if (event.data?.type === "modalClosed") {
					setIsOpen(true);
				}
			} else {
				console.warn("Untrusted origin:", event.origin);
			}
		};
		window.addEventListener("message", handleMessage);
		return () => {
			window.removeEventListener("message", handleMessage);
		};
	}, []);

	return (
		<>
			<div className="campaign-web">
				<div className="flex-column-box">
					<div className="campaign-web-left">
						<div className="web-top-header">
							<img className="title"
								 src={holititle}
								 alt="title"/>
						</div>
						{/* <div className="campaign-divider"></div> */}

						<div className="campaign-revenue-box">
							<div className="campaign-border"></div>
							<div className="campaign-revenue">
								<h4>YOUR REVENUE</h4>
								<h1>{data?.homeCard?.revenueCard?.total}</h1>
							</div>
							<div className="campaign-rank">
								
								{data?.homeCard?.rankCard?.title}{data?.homeCard?.rankCard?.subText} RANK
								<img
									src="https://cdn-cp-assets-public.classplus.co/campaigns-assets/rank-point-cons-web-holi-2026.png"
									alt="cards" width={20}/>
							</div>
						</div>
						<div className="campaign-progress-bar">
							<ProgressMeter
								width={data?.homeCard?.revenueCard?.progressBar > 100 ? 100 : data?.homeCard?.revenueCard?.progressBar}
								thick={18}
								isQualified={true}
								data={data?.homeMileStone?.revenue}>
							</ProgressMeter>
						</div>
						<div className="progress-completed">
							<h4>{data?.homeCard?.revenueCard?.progressBar >= 100 ? '100' : data?.homeCard?.revenueCard?.progressBar}%
								Completed</h4>
							<h4>Goal:&nbsp; {data?.homeCard?.revenueCard?.goal}</h4>
						</div>
						
						{/* <div className="campaign-carousel-caption">
							<h4>The 3x Store</h4>
							<p>3x your earnings by our Specialised features & get chance to win amazing gifts.</p>
						</div>
						<div className="sleekCarouselContainer">
							<SleekCarousel bottomCardData={bottomCardWebData} campaignOrg={campaignOrg}/>
						</div> */}
						
					</div>
					<div className="campaign-web-right">
						<div className="campaign-message-box">
							<h3>Share a gift to your students</h3>
							<div className="campaign-message" onClick={() => openFrameFun('overview')}>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								xmlns="http://www.w3.org/2000/svg"
								>
								<defs>
									
									<linearGradient id="chatGradient" x1="0%" y1="0%" x2="100%" y2="0%">
									<stop offset="0%" stop-color="#9113CC" />
									<stop offset="100%" stop-color="#BA1C5B" />
									</linearGradient>
								</defs>

								<path
									d="M15 0H5C2.24 0 0 2.23 0 4.98V10.96V11.96C0 14.71 2.24 16.94 5 16.94H6.5C6.77 16.94 7.13 17.12 7.3 17.34L8.8 19.33C9.46 20.21 10.54 20.21 11.2 19.33L12.7 17.34C12.89 17.09 13.19 16.94 13.5 16.94H15C17.76 16.94 20 14.71 20 11.96V4.98C20 2.23 17.76 0 15 0ZM6 10C5.44 10 5 9.55 5 9C5 8.45 5.45 8 6 8C6.55 8 7 8.45 7 9C7 9.55 6.56 10 6 10ZM10 10C9.44 10 9 9.55 9 9C9 8.45 9.45 8 10 8C10.55 8 11 8.45 11 9C11 9.55 10.56 10 10 10ZM14 10C13.44 10 13 9.55 13 9C13 8.45 13.45 8 14 8C14.55 8 15 8.45 15 9C15 9.55 14.56 10 14 10Z"
									fill="url(#chatGradient)"
								/>
								</svg>
								Send a special message to your students
								<img
									src={arrowright}
									alt="arrow" width={24}/>
							</div>
						</div>
						{tutorData &&
							<div className="campaign-tutor-web">
								<div className="tutor-column-header">
									<h3>Tutor of the day</h3>
									<button onClick={() => openFrameFun('leaderboard')}>View Leaderboard<img
										src={arrowright}
										alt="arrow" width={16}/></button>
								</div>
								<div className="campaign-tutor">
									<img src={tutorData?.orgLogo} alt="logo" width={56}/>
									<p>{tutorData?.orgName}</p>
								</div>
							</div>
						}
						<div className='campaign-task-container'>
							<div className="task-column-header">
								<h3>Complete task & win big</h3>
								<button onClick={() => openFrameFun('tasks')}>View All Tasks<img
									src={arrowright}
									alt="arrow" width={16}/></button>
							</div>
							{coinTasksData?.slice(!tutorData ? 0 : 1, 2)?.map((item, i) => {
								return (
									<div className='campaign-task-column' key={i}>
										<div className='task-card-first-row'>
											<div className='task-card-upper-row'>
												<div className='task-title-wrapper'>
													<div className='task-title'>{item?.task}</div>
													{item?.statType === 3 ? (
														<p className='task-title-small'>{item?.completedText}</p>
													) : (
														<p className='task-title-small'>{item?.total || 0} {item?.completedText}</p>
													)}
												</div>
												<ProgressMeter
													width={item?.percentage}
													isQualified={true}
													data={data?.homeMileStone?.revenue}
												></ProgressMeter>
											</div>
											<div className='task-coin-wrapper'>
												<img
													src={"https://cdn-cp-assets-public.classplus.co/campaigns-assets/rank-point-cons-web-holi-2026.png"}    
													alt="circle-point" width={20} height={20}/>
												<p className='task-title-small'>{item?.points} Points</p>
											</div>
											<div className='task-coin-wrapper'>
												<button className='task-card-btn'
														onClick={() => openFrameFun('tasks')}>{item?.button?.text}
												</button>
											</div>
										</div>
										<span className='task-divider-line'></span>
										<div className='task-card-second-row'>
											{item?.taskInfo}
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>
			{showTutorFrame &&
				<div className={`${'campaignPopUp campaignPopUpFrame show'}`}>
					<div className="campaignPopUpContent">
						{isOpen && <div className="campaignPopUpHeader">
							<h4>Happy Holi Sale 2026</h4>
							<button onClick={closedTutorFrameFun}><img
								src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/modal-close-icon.png"
								width={24} alt="icon"/></button>
						</div>}
						<div className="campaignPopUpBody">
							<iframe
								className="campaign-tutor-frame"
								ref={iframeRef}
								src={frameUrl}
								allow="fullscreen; autoplay"
								sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
							></iframe>

						</div>
					</div>
					{/*<div className="campaign-close-overlay" onClick={closedTutorFrameFun}></div>*/}
				</div>
			}
		</>
	);
};

export default withRouter(Campaign);
